if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        // Delegated so that items copied in later (lazy-loaded country lists) work too.
        this.elements.panel.addEventListener('click', (event) => {
          const item = event.target.closest('a[data-value]');
          if (item && this.elements.panel.contains(item)) this.onItemClick(event, item);
        });
      }

      // Lists rendered with data-lazy-src are empty in the HTML; fetch the items
      // (sections/country-list.liquid) the first time the selector is opened.
      fillLazyList() {
        const list = this.elements.panel.querySelector('[data-lazy-src]');
        if (!list || list.children.length || list.dataset.loading) return;
        const src = list.dataset.lazySrc;
        list.dataset.loading = '1';
        LocalizationForm.lists = LocalizationForm.lists || {};
        LocalizationForm.lists[src] =
          LocalizationForm.lists[src] ||
          fetch(src).then((r) => {
            if (!r.ok) throw new Error(r.status);
            return r.text();
          });
        LocalizationForm.lists[src]
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const source = doc.querySelector('.disclosure__list');
            if (source) list.innerHTML = source.innerHTML;
          })
          .catch(() => {
            delete LocalizationForm.lists[src];
          })
          .finally(() => {
            delete list.dataset.loading;
          });
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event, item) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = (item || event.currentTarget).dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.fillLazyList();
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}
